import { render, staticRenderFns } from "./medical-guide.vue?vue&type=template&id=52af10b0&scoped=true"
import script from "./medical-guide.vue?vue&type=script&lang=js"
export * from "./medical-guide.vue?vue&type=script&lang=js"
import style0 from "./medical-guide.vue?vue&type=style&index=0&id=52af10b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52af10b0",
  null
  
)

export default component.exports